module.exports = __webpack_public_path__ + "img/logo.c0e0ab24.png";